import React, { useEffect } from 'react'
import "./RestaurantItemDetail.css"
// import { Link } from "react-router-dom"
import { useDispatch, useSelector } from 'react-redux'
import Header from '../Header'
import { Container } from 'react-bootstrap'
import { fetchRestaurantDetails } from '../../redux/actions/restaurantItemDetailsAction'
import FoodItem from '../FoodItem/FoodItem'
import Footer from '../Footer/footer'

function RestaurantItemDetail(props) {

    const store = useSelector(state => state.restaurantsDetailReducer.restaurantDetails);

    const dispatch = useDispatch();

    const getRestaurantDetails = () => {
        dispatch(fetchRestaurantDetails({ id: props.match.params.id }))
    }

    useEffect(() => {
        getRestaurantDetails()
    }, [])

    React.useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return (
        <>
            <Header />
            <div className='restaurant-item-container'>
                <div className='restaurant-item-banner'>
                    <Container className='d-flex'>
                        <img className="restaurant-banner-item-image" src={store.image_url} />
                        <div className='restaurant-banner-details-container'>
                            <h1 className='restaurant-name-banner'>{store.name}</h1>
                            <p className='restaurant-location-ratings'>{store.cuisine}</p>
                            <p className='restaurant-location-ratings'>{store.location}</p>
                            <div className='d-flex mt-3'>
                                <div className='me-5'>
                                    <i className="fa-regular fa-star restaurant-rating"></i>
                                    <span style={{ color: "white" }} className='restaurant-location-ratings'>{store.rating} </span>
                                    <p className='restaurant-location-ratings'>({store.reviews_count} ratings)</p>
                                </div>
                                <div>
                                    <span style={{ color: "white" }} className='restaurant-location-ratings'>₹ {store.cost_for_two} </span>
                                    <p className='restaurant-location-ratings'>Cost for Two</p>
                                </div>
                            </div>
                        </div>
                    </Container>
                </div>

                <Container>
                    <div className='restaurants-list-container'>
                        {
                            store.food_items && store.food_items.length &&
                            store.food_items.map((foodItem) => <FoodItem key={foodItem.id} foodItem={foodItem} />)
                        }
                    </div>
                    <Footer />
                </Container>

            </div>
        </>
    )
}

export default RestaurantItemDetail